import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getAnalytics } from "firebase/analytics";



const firebaseConfig = {
  apiKey: "AIzaSyBmr7X8dehmcyvJpA0-iehHk_ibzoG5aOQ",
  authDomain: "employpilot-3e29c.firebaseapp.com",
  projectId: "employpilot-3e29c",
  storageBucket: "employpilot-3e29c.firebasestorage.app",
  messagingSenderId: "273849303633",
  appId: "1:273849303633:web:da5ce2fa2e336dffa6ae70"
};


// 🔥 INIT APP
const app = initializeApp(firebaseConfig);

// 🔥 EXPORT EVERYTHING CLEANLY
export const auth = getAuth(app);
export const db = getFirestore(app);
export const analytics = getAnalytics(app); // ✅ no async, no promise

export default app; // ✅ THIS FIXES YOUR "app not exported" ERROR